<template>
    <div class="input__container" :class="[{ 'input-default': isInputDefault }]">
        <label class="label">{{ getTranslatedText(inputItem.label) }}</label>
        <div class="input__container-content">
            <img
                v-if="inputItem.icon && inputItem.icon !== ''"
                class="input__container-content-icon"
                :src="require(`@/public/img/${$store.state.config.skin}/${inputItem.icon}.svg`)"
                :alt="inputItem.icon"
            />
            <template v-if="inputItem.isNumericPassword">
                <input
                    :class="inputItem.className ? inputItem.className : 'input-text input-numeric'"
                    :value="value"
                    type="text"
                    inputmode="numeric"
                    :required="inputItem.required"
                    :placeholder="getTranslatedText(inputItem.placeholder)"
                    autocomplete="off"
                    aria-autocomplete="none"
                    @input="(event) => onChangeValue(event, inputItem.name)"
                    @keypress="validateNumberInput($event)"
                    @focus="togglePasswordVisibility(true)"
                    @blur="togglePasswordVisibility(false)"
                    ref="passwordInput"
                />
            </template>
            <input
                v-else
                :class="inputItem.className ? item.className : 'input-text'"
                :type="inputItem.type"
                :value="value"
                :pattern="inputItem.pattern"
                :inputmode="inputItem.inputmode"
                :required="inputItem.required"
                :placeholder="getTranslatedText(inputItem.placeholder)"
                autocomplete="off"
                aria-autocomplete="none"
                @input="(value) => onChangeValue(value, inputItem.name)"
                :autocapitalize="inputItem?.isCapsLock ? 'characters' : 'none'"
            />
        </div>
        <div class="input__note" v-if="inputItem?.isNote">
            {{ getTranslatedText(inputItem.noteValue) }}
        </div>
    </div>
</template>

<script>
import languageMixins from '@/mixins/language-mixins';
import utilsMixin from '@/mixins/function-utils';
import EventBus from '@/utils/EventBus';

export default {
    mixins: [languageMixins, utilsMixin],
    props: {
        inputItem: {
            type: Object,
            default: () => ({}),
        },
        nameFunction: {
            type: String,
            default: '',
        },
        value: {
            type: String,
            default: '',
        },
        isInputDefault: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        onChangeValue(event, name) {
            let value = event.target.value;
            if (this.inputItem.isCapsLock) {
                value = value.toUpperCase();
                event.target.value = value;
            }

            const param = { event, name };
            if (!this.isStrEmpty(this.nameFunction)) {
                EventBus.emit(this.nameFunction, param);
            } else {
                this.$emit('on-change-input-common', param);
            }
        },
        validateNumberInput(event) {
            const char = String.fromCharCode(event.which);
            if (!/[0-9]/.test(char)) {
                event.preventDefault();
            }
        },
        togglePasswordVisibility(isVisible) {
            const input = this.$refs.passwordInput;
            input.type = 'text';
        },
    },
};
</script>

<style lang="scss">
@import '@/public/scss/common/input.scss';
</style>
